export const PAYMENTS_ENABLED = true;
export const HERO_IMG = "https://guia.lermahoy.es/catalina-hero.jpg";
// El vídeo de presentación ya no vive en Plesk (esa carpeta se borró):
// ahora lo sirve el propio backend desde el volumen privado de Railway.
export const INTRO_VIDEO = `${process.env.REACT_APP_BACKEND_URL}/api/video-intro`;
